import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {ReportHelpModalComponent} from "../../components/report-help-modal/report-help-modal.component";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {ReportService} from "../../services/report/report.service";
import { OrganisationService } from '../..//services/organisation/organisation.service';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-report',
  templateUrl: './report.component.pug',
  styleUrls: ['./report.component.scss'],
  standalone: false
})
export class ReportComponent implements OnInit {


  uid: string | null = '';
  reportHelpModal: BsModalRef;
  reportData: any;
  peopleProfile = false;
  loading = true;
  noRatingsData = false;
  dataError = false;
  emptyReportData = [];
  emptyManagerData = [];

  get fullName() { return `${this.reportData?.exitee?.first_name} ${this.reportData?.exitee?.last_name}` }
  get originPage() { return this.route.snapshot.params.s === 'profile' ? this.fullName : $localize`Requests` };

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private viewportScroller: ViewportScroller,
    private report: ReportService,
    private route: ActivatedRoute,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
    public organisationService: OrganisationService,
    private permissionsService: PermissionsService,
  ) {
    const state = this.router.getCurrentNavigation()?.extras?.state;

    this.reportHelpModal = new BsModalRef();
  }

  ngOnInit(): void {
    this.uid = this.route.snapshot.paramMap.get('uid')
    this.report.getReport(this.uid).subscribe((data: any) => {
      this.reportData = data;
      this.checkManagerData();
      this.loading = false;
    }, error => {
      if (error.status === 403) {
          this.router.navigate(['/no-access']);
        }
      else{
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      }
      this.loading = false;
      this.dataError = true;
    });
  }

  checkManagerData() {
    const managerData = this.reportData.managers_feedback;
    const employmentData = this.reportData.employment;

    if (!managerData?.skills && !managerData?.competencies &&
      !employmentData?.skills && !employmentData?.competencies
       ) {
      this.noRatingsData = true;
    }
  }

  navigateBack() {
    if(this.route.snapshot.params.s === 'profile') {
      this.router.navigate(['people', 'profile', this.reportData?.exitee?.person_uid])
    } else {
      this.router.navigate(['requests']);
    }
  }

  scrollToElement(id: string): void {
    this.showDropdownOnScroll(id);
    document.getElementById(id)?.scrollIntoView({behavior: 'smooth'});
  }

  showDropdownOnScroll(id: string){
    const managersFeedbackLength = this.reportData.managers_feedback?.length;
    if(!managersFeedbackLength){
      if(id === "ratings"){
        this.emptyReportData[id] = true
      }
      if(id === "managerRecommendation"){
        this.emptyManagerData['managerRec'] = true
      }
    }else if(managersFeedbackLength !== 0 && managersFeedbackLength !== undefined){
      if(id === "ratings"){
        this.reportData.managers_feedback = this.reportData.managers_feedback?.map((item: any) => {
          item[id] = true;
          return item;
        })
      }
      if(id === "managerRecommendation"){
        this.reportData.managers_feedback[0]['managerRec'] = true
        this.reportData.managers_feedback = this.reportData.managers_feedback?.map((item: any) => {
          item['managerRec'] = true;
          return item;
        })
      }
    }
  }

  showHelp() {
    this.reportHelpModal = this.modalService.show(ReportHelpModalComponent, {
      class: 'modal-dialog-centered modal-lg'
    });
  }

  showDropdown(item, dropdownType) {
    if (item[dropdownType]) {
      item[dropdownType] = false;
    } else {
      item[dropdownType] = true;
    }
  }
  openProfile() {
    this.router.navigate([`/people/profile/${this.reportData?.exitee?.person_uid}`]);
  }
}
